var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('label',{staticClass:"radio-or-checkbox"},[_c('input',{attrs:{"name":_vm._name,"type":_vm.type},domProps:{"checked":_vm.currentValue === _vm.value || _vm.currentValue === true || _vm.checked},on:{"change":_vm.change}}),_c('span',{staticClass:"indicator",class:{
      box: _vm.isBox,
      circle: !_vm.isBox,
      'no-text-highlight': !_vm.textHighlighted,
    },style:(_vm.indicatorStyle)},[_vm._t("indicator",function(){return [_c('font-awesome-icon',{attrs:{"icon":!_vm.isBox ? 'circle' : 'check',"color":_vm.color,"aria-hidden":"true"}})]})],2),_c('span',{staticClass:"content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }